module.exports = __webpack_public_path__ + "static/media/mc_symbol.1eb8d109.png";